module.exports = "/lucky-balls/img/infobox/info_Box_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_003.png
// module id = 1068
// module chunks = 0